import { LANGS, langPath } from "../seo/site";

/* Served by nginx with a real 404 status (build/404.html) and rendered by the
   router for any unknown path. */

const CSS = `
.tk-nf { min-height: 100vh; margin: 0; display: flex; align-items: center; justify-content: center; padding: 2rem 1rem; background: #fafafa; color: #18181b; text-align: center;
  font-family: "Poppins", "Poppins Fallback", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; }
.tk-nf h1 { margin: 0 0 .5rem; font-size: 2.5rem; font-weight: 800; letter-spacing: -.03em; }
.tk-nf p { margin: 0 0 1.5rem; color: #52525b; line-height: 1.6; }
.tk-nf ul { list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: wrap; gap: .5rem; justify-content: center; }
.tk-nf a { display: inline-block; padding: .6rem 1rem; border: 1px solid #e4e4e7; border-radius: .75rem; background: #fff; color: inherit; text-decoration: none; font-weight: 600; }
.tk-nf a:hover { border-color: #a1a1aa; }
`;

export default function NotFound() {
  return (
    <main className="tk-nf">
      <style>{CSS}</style>
      <div>
        <h1>404</h1>
        <p>
          <span lang="sv">Sidan finns inte.</span> <span lang="en">Page not found.</span>
        </p>
        <ul>
          {LANGS.map((l) => (
            <li key={l.code}>
              <a href={langPath(l.code)} hrefLang={l.code} lang={l.code}>{l.native}</a>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
